import z from 'zod';

const entityReferenceSchema = z.object({
  id: z.string().optional(),
  logicalName: z.string().optional(),
  name: z.string().optional(),
});

export const pp_championshipPlayerZodObject = {
  championshipPlayer: z.object({
    id: z.string(), // Required Dataverse GUID

    // base
    name: z.string().nullable().optional(),
    firstName: z.string().optional(),
    lastName: z.string().optional(),
    //Registration
    registrationStatus: z.string().nullable().optional(),
    onSiteRegistrationCompletedDate: z.string().nullable().optional(),

    // Championship Address
    championshipAddressLine1: z.string().nullable().optional(),
    championshipAddressLine2: z.string().nullable().optional(),
    championshipCountry: entityReferenceSchema.nullable().optional(),
    championshipCountyOrState: z.string().nullable().optional(),
    championshipEmail: z.string().email().nullable().optional(),
    championshipMobile: z.string().nullable().optional(),
    championshipMobileCountryCode: z.string().nullable().optional(),
    championshipPostcodeOrZipcode: z.string().nullable().optional(),
    championshipTownOrCity: z.string().nullable().optional(),

    // Player Address
    playerAddressCountry: entityReferenceSchema.nullable().optional(),
    playerAddressLine1: z.string().nullable().optional(),
    playerAddressLine2: z.string().nullable().optional(),
    playerCountyOrState: z.string().nullable().optional(),
    playerPostcodeOrZipCode: z.string().nullable().optional(),
    playerTownOrCity: z.string().nullable().optional(),

    // Hospitality / Complimentary / Paid
    finalDayComplimentary: z.string().nullable().optional(),
    finalDayPaid: z.string().nullable().optional(),
    fridayComplimentary: z.string().nullable().optional(),
    fridayPaid: z.string().nullable().optional(),
    mondayComplimentary: z.string().nullable().optional(),
    mondayPaid: z.string().nullable().optional(),
    saturdayComplimentary: z.string().nullable().optional(),
    saturdayPaid: z.string().nullable().optional(),
    sundayComplimentary: z.string().nullable().optional(),
    sundayPaid: z.string().nullable().optional(),
    thursdayComplimentary: z.string().nullable().optional(),
    thursdayPaid: z.string().nullable().optional(),
    tuesdayComplimentary: z.string().nullable().optional(),
    tuesdayPaid: z.string().nullable().optional(),
    wednesdayComplimentary: z.string().nullable().optional(),
    wednesdayPaid: z.string().nullable().optional(),

    // Sustainability
    sustainabilityCarbonOffset: z.string().nullable().optional(),
    sustainabilityCarbonOffsetOther: z.string().nullable().optional(),
    sustainabilityDepartureCity: z.string().nullable().optional(),
    sustainabilityDestinationCity: z.string().nullable().optional(),
    sustainabilityMethodOfTransportArrival: z.string().nullable().optional(),
    sustainabilityMethodOfTransportDeparture: z.string().nullable().optional(),

    // Tax
    taxAddressCountry: entityReferenceSchema.nullable().optional(),
    taxAddressLine1: z.string().nullable().optional(),
    taxAddressLine2: z.string().nullable().optional(),
    taxCountyOrState: z.string().nullable().optional(),
    taxDocKeyContact: z.string().nullable().optional(),
    taxPostcodeOrZipcode: z.string().nullable().optional(),
    taxTownOrCity: z.string().nullable().optional(),
    countryOfTaxation: entityReferenceSchema.nullable().optional(),

    // Ticketing
    ticketingContactEmail: z.string().email().nullable().optional(),
    ticketingContactName: z.string().nullable().optional(),

    // PlayerTour Affiliation
    tourAffiliation: entityReferenceSchema.nullable().optional(),

    //Policies Acceptance
    antiDopingPolicyAcceptance: z.boolean().nullable().optional(),
    antiBettingPolicyAcceptance: z.boolean().nullable().optional(),
    allPoliciesAccepted: z.boolean().nullable().optional(),

    //Sections complete
    contactDetailsSectionComplete: z.boolean().nullable().optional(),
    playerHomeAddressSectionComplete: z.boolean().nullable().optional(),
    championshipAddressSectionComplete: z.boolean().nullable().optional(),
    prizeMoneySectionComplete: z.boolean().nullable().optional(),

    //has started pre-registration flag
    hasStartedPreRegistration: z.boolean().nullable().optional(),
  }),
};
